<template>
    <div class="row">
        <div class="col-xs-12 login-container">
            <div class="login-form">
                <div class="text-center">
                    <h4>Login</h4>
                </div>
                <div class="input-group mt-30 block">
                    <label for="loginEmail">Email</label>
                    <input type="text"
                           id="loginEmail"
                           name="email"
                           v-model="email"
                           class="form-control" />
                </div>
                <div class="input-group mt-30 block" v-show="!forgotPassword">
                    <label for="loginPassword">Password</label>
                    <input type="password"
                           id="loginPassword"
                           name="password"
                           v-model="password"
                           @keyup.enter="submit()"
                           class="form-control" />
                </div>
                <small class="text-danger">{{ invalidCombo ? 'Invalid email & password combination' : ''}}</small>
                <div class="button-container mt-30">
                    <button class="btn btn-default btn-sm"
                            :disabled="submitting"
                            @click="forgotPassword = !forgotPassword">
                        {{ forgotPassword ? 'Login' : 'Forgot Password' }}
                    </button>
                    <button class="btn btn-primary btn-sm"
                            @click="submit()"
                            :disabled="!formReady()">
                        <span v-show="submitSuccess">{{ forgotPassword }}</span>
                        {{ forgotPassword ? 'Send Reset Email' : 'Login' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { validEmail } from '../../helpers/validators';
    import { errorAlert, successAlert } from '../../helpers/alerts';
    import { getRecaptchaToken } from '../../helpers/google';

    export default {
        data() {
            return {
                email: '',
                password: '',
                forgotPassword: false,
                submitting: false,
                invalidCombo: false,
                submitSuccess: false,
            }
        },
        methods: {
            formReady() {
                return this.forgotPassword ?
                    (validEmail(this.email) && !this.submitting) :
                    (validEmail(this.email) && this.password && !this.submitting);
            },
            async submit() {
                if(!this.formReady()) {
                    return;
                }
                this.submitting = true;
                this.invalidCombo = false;
                if(this.forgotPassword) {
                    axios.post('/auth/password/forgot', {
                        email: this.email,
                        recaptcha_token: await getRecaptchaToken('forgot_password_request')
                    })
                        .then(() => {
                            successAlert('An email with a password reset link has been sent to your email.');
                        })
                        .catch(() => {
                            errorAlert('An error occurred trying to send your password reset email');
                            this.submitting = false;
                        });
                    return;
                }
                axios.post('/login', {
                    email: this.email,
                    password: this.password,
                    recaptcha_token: await getRecaptchaToken('login_request')
                })
                    .then(response => {
                        if(response.data.invalid) {
                            this.invalidCombo = true;
                            this.submitting = false;
                            return;
                        }
                        window.location.assign("/");
                    })
                    .catch(() => {
                        errorAlert('An error occurred trying to log you in');
                        this.submitting = false;
                    });
            }
        }
    }
</script>

<style scoped>
    .login-container {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }
    .login-form {
        width: 100%;
        max-width: 415px;
        margin-top: 10%;
    }
    .button-container {
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
    }
</style>
